import { jsx as _jsx } from "react/jsx-runtime";
import noop from "lodash/noop";
import { createContext, useCallback, useContext, useMemo } from "react";
import { useLocalStorage } from "__barrel_optimize__?names=useLocalStorage!=!react-use";
import { VIDEO_TIME_FORMAT } from "~/constants/localStorageKeys";
export var VideoTimeFormat;
(function(VideoTimeFormat) {
    VideoTimeFormat["Standard"] = "standard";
    VideoTimeFormat["Frames"] = "frames";
    VideoTimeFormat["Timecode"] = "timecode";
})(VideoTimeFormat || (VideoTimeFormat = {}));
const DEFAULT_VALUE = {
    format: "standard",
    handleUpdateFormat: noop
};
const VideoTimeFormatContext = /*#__PURE__*/ createContext(DEFAULT_VALUE);
export const VideoTimeFormatProvider = (param)=>{
    let { children, clipId } = param;
    const [values, setValues] = useLocalStorage(VIDEO_TIME_FORMAT, {});
    const format = useMemo(()=>{
        var _values_clipId;
        return (_values_clipId = values === null || values === void 0 ? void 0 : values[clipId]) !== null && _values_clipId !== void 0 ? _values_clipId : "standard";
    }, [
        values,
        clipId
    ]);
    const handleUpdateFormat = useCallback((format)=>{
        setValues({
            ...values,
            [clipId]: format
        });
    }, [
        clipId,
        setValues,
        values
    ]);
    const value = useMemo(()=>{
        return {
            format,
            handleUpdateFormat
        };
    }, [
        format,
        handleUpdateFormat
    ]);
    return /*#__PURE__*/ _jsx(VideoTimeFormatContext.Provider, {
        value: value,
        children: children
    });
};
export const useVideoTimeFormatContext = ()=>{
    const context = useContext(VideoTimeFormatContext);
    if (context === DEFAULT_VALUE) {
        throw new Error("useVideoTimeFormatContext must be used within a VideoTimeFormatProvider");
    }
    return context;
};
